<div class="agpr-agentBanner">
    <div
        class="agpr-agentBanner-header"
        [ngClass]="{ 'agpr-agentBanner-header--noExpand': !showExpandButton }"
    >
        <span
            class="agpr-agentBanner-headerTitle"
            [ngClass]="{ 'agpr-agentBanner-headerTitle--centered': !showExpandButton}"
        >
            {{ headerTitle | localize }}
        </span>
        @if (showExpandButton) {
            <agpr-button
                class="agpr-agentBanner-expandToggle"
                [style]="buttonTypes.icon"
                [icon]="agentBannerExpanded ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
                [id]="id + '_agentBannerToggle'"
                (click)="toggle()"
            ></agpr-button>
        }
    </div>
    <div
        #bannerContentWrapper
        class="agpr-agentBanner-contentWrapper"
        [@bannerContent]="agentBannerExpanded ? 'visible' : 'hidden'"
        (@bannerContent.done)="onToggleDone($event)"
        [ngClass]="{ 'agpr-agentBanner-contentWrapper--overflown': !agentBannerExpanded || animating }"
    >
        <div
            class="agpr-agentBanner-input"
            [ngClass]="{ 'agpr-agentBanner-input--noExpand': !showExpandButton }"
        >
            <div class="agpr-agentBanner-inputPromptWrapper">
                <agpr-textarea-input
                    class="agpr-agentBanner-inputTextarea"
                    [placeholder]="placeholder | localize"
                    [resize]="resizeEnum.none"
                    [ngModel]="naturalLanguagePrompt"
                    (ngModelChange)="naturalLanguagePromptChange.emit($event)"
                    [ngModelOptions]="{standalone: true}"
                    [bottomMargin]="false"
                    [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                    [rows]="4"
                    [agentic]="true"
                ></agpr-textarea-input>
                <agpr-button
                    #naturalLanguageTarget
                    class="agpr-agentBanner-inputSubmit"
                    [style]="buttonTypes.primary"
                    label="Monitoring.search.prcopilot.start"
                    tailIcon="fa-regular fa-arrow-right"
                    [id]="id + '_agentBannerSubmit'"
                    [tooltip]="naturalLanguagePrompt.trim() ? submitTooltip : submitTooltipEmpty"
                    [disabled]="!naturalLanguagePrompt.trim()"
                    (click)="submitClick()"
                ></agpr-button>
            </div>
            @if (hasAgentDebug) {
                <agpr-textarea-input
                    class="agpr-agentBanner-inputTextarea"
                    [label]="'Monitoring.search.prcopilot.taskDescription' | localize"
                    [ngModel]="taskDescription"
                    (ngModelChange)="taskDescriptionChange.emit($event)"
                    [ngModelOptions]="{standalone: true}"
                ></agpr-textarea-input>
                <agpr-textarea-input
                    class="agpr-agentBanner-inputTextarea"
                    [label]="'Monitoring.search.prcopilot.systemPrompt' | localize"
                    [ngModel]="systemPrompt"
                    (ngModelChange)="systemPromptChange.emit($event)"
                    [ngModelOptions]="{standalone: true}"
                ></agpr-textarea-input>
                <agpr-textarea-input
                    class="agpr-agentBanner-inputTextarea"
                    [label]="'Monitoring.search.prcopilot.topicSystemPrompt' | localize"
                    [ngModel]="topicSystemPrompt"
                    (ngModelChange)="topicSystemPromptChange.emit($event)"
                    [ngModelOptions]="{standalone: true}"
                ></agpr-textarea-input>
                <agpr-button
                    class="agpr-agentBanner-inputSubmit"
                    [style]="buttonTypes.primary"
                    [id]="id + '_agentBannerDirectSubmit'"
                    [disabled]="!naturalLanguagePrompt.trim()"
                    (click)="submitDirect.emit()"
                >Topic Agent Direct</agpr-button>
            }
        </div>
    </div>
</div>
